export default {
  detectionDetail: {
    component: () =>
      import("@/mods/setting/detectionScheme/detail/DetectionSchemeDetail"),
  },
};
